import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,_vm._b({staticStyle:{"font-size":"16px"},attrs:{"dark":"","rounded":"","depressed":""},on:{"click":_vm.click}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }